module.exports = __webpack_public_path__ + "img/Sharp Prong Tip.7f2a7de3.png";